import React, { useState, useEffect } from "react";
import { Input } from "antd";
import dayjs from "dayjs";
import Error from "../Error";

const DaysComponent = React.forwardRef((props, focus) => {
    const { index, ind, val, form, setForm, getFormdata, createdDate } = props;

    const [calculatedDate, setCalculatedDate] = useState(null);
    const [displayDays, setDisplayDays] = useState(null);

    useEffect(() => {
        if (val?.form?.value && createdDate) {
            const dueDateValue = new Date(val.form.value);
            const invoiceDate = new Date(createdDate);

            if (!isNaN(dueDateValue) && !isNaN(invoiceDate)) {
                const diffTime = Math.abs(dueDateValue - invoiceDate);
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)); 
                setDisplayDays(diffDays);
                setCalculatedDate(dueDateValue);
            }
        }
    }, [val?.form?.value, createdDate]);

    const handleDays = (e, index, ind) => {
        const days = parseInt(e.target.value);

        if (!days || days < 0) {
            setCalculatedDate(null);
            setDisplayDays(null);
            return;
        }

        const today = createdDate ? new Date(createdDate) : new Date();
        const dueDate = new Date(today);
        dueDate.setDate(today.getDate() + days);

        setCalculatedDate(dueDate);
        setDisplayDays(days);

        let data = [...form];
        data[index].options[ind].form.value = dueDate;

        setForm(data);
        getFormdata(data);
    };

    return (
        <>
            <Input
                type="number"
                key={index?.toString()?.concat(ind)}
                id={index?.toString()?.concat(ind)}
                name={val?.form?.name}
                placeholder="Enter number of days"
                className={val?.form?.className ? val?.form?.className : "text-regular w-full"}
                ref={focus.current[val?.form?.name?.concat(index + "" + ind)]}
                onChange={(e) => handleDays(e, index, ind)}
                value={displayDays !== null ? displayDays : ""}
                autoComplete="off"
                disabled={val?.form?.disabled ? val?.form?.disabled : false}
            />

            {calculatedDate && (
                <div style={{ marginTop: "6px", fontSize: "13px", color: "#555" }}>
                    Due Date: {dayjs(calculatedDate).format("DD/MM/YYYY")}
                </div>
            )}

            {val?.form?.value && !calculatedDate && createdDate && (
                <div style={{ marginTop: "6px", fontSize: "13px", color: "#555" }}>
                    Current Due Date: {dayjs(val.form.value).format("DD/MM/YYYY")}
                </div>
            )}

            <Error id={val?.form?.name?.concat(index + "" + ind)} />
        </>
    );
});

export default DaysComponent;